const helpers = require('./helpers');
const featuresHelpers = require('./helpers.features');
const { COOKIE, EVENT } = require('../constants');

const utils = (storeUtils = window.flex) => {

    const { trigger, getStore } = storeUtils;
    const { isFeatureToggleEnabled } = featuresHelpers(storeUtils);

    function ajax(options = {}) {
        $.ajax({
            url: getApiUrl(options.url),
            async: !options.sync,
            type: options.type || "POST",
            dataType: options.dataType || "json",
            contentType: options.contentType || "application/json",
            data: (typeof options.data === 'string' || options.data instanceof String) ? options.data : JSON.stringify(options.data),
            headers: getHeaders(),
            success: options.success,
            error: options.error || function (jqXHR, textStatus, errorThrown) {
                handleAjaxError(jqXHR, textStatus, errorThrown);
            }
        });
    }

    // Must be invoked off of util object presently
    function getApiUrl(options) {
        const url = options.url || options;
        const store = getStore();

        // TODO: review
        let { appContext } = store.toJS();
        let apiBaseUrl = appContext && appContext.app && appContext.app.api ? appContext.app.api : (window.flex ? window.flex.apiBaseUrl : '');

        let baseUrl = apiBaseUrl,
            serviceMatches,
            service;

        if (!store || !helpers.objectPathExists(store, 'appContext', 'baseUrls')) {
            return baseUrl + url;
        }
        baseUrl = store.appContext.baseUrls.api || baseUrl;

        if (!store.appContext.baseUrls.apiServices) {
            return baseUrl + url;
        }

        serviceMatches = url.match(/^\/api\/v[0-9]+\/([^\/]*)\/.*$/);
        service = serviceMatches && serviceMatches.length > 1 ? serviceMatches[1] : '';

        baseUrl = !service ? baseUrl : (helpers.ifUndefined(store.appContext.baseUrls.apiServices[service], baseUrl) || baseUrl);
        return baseUrl + url;
    }

    function getContentUrl(options) {
        const url = options.url || options;
        const store = getStore();
        let baseUrl = window.flex ? window.flex.contentBaseUrl : '',
            moduleMatches,
            module;

        if (!store || !helpers.objectPathExists(store, 'appContext', 'baseUrls')) {
            return baseUrl + url;
        }
        baseUrl = store.appContext.baseUrls.content || baseUrl;

        if (!store.appContext.baseUrls.contentModules) {
            return baseUrl + url;
        }

        moduleMatches = url.replace('/content', '').match(/^\/([^\/]*)\/.*$/);
        module = moduleMatches && moduleMatches.length > 1 ? moduleMatches[1] : '';

        baseUrl = !module ? baseUrl : (helpers.ifUndefined(store.appContext.baseUrls.contentModules[module], baseUrl) || baseUrl);
        return baseUrl + url;
    }

    function getHeaders() {
        const store = getStore();
        const host = helpers.getCookie(COOKIE.FLEX_HOST) || window.location.host;
        const su = helpers.getCookie(COOKIE.FLEX_SU);

        let headers = {
            'Flex-Context': `${host}||${window.location.href}|${su}`
        };

        if (host.includes("localhost")) {
            headers = {};
        }

        if (!store || !store.session || !store.session.token) {
            return headers;
        }

        let isOAuthEnabled = isFeatureToggleEnabled("UseOAuthFlow");

        let bearerToken = `Bearer ${isOAuthEnabled ? store.session.oAuthToken : store.session.token}`;

        headers['Authorization'] = bearerToken;
        headers['X-CSRF-TOKEN'] = store.session.csrfToken;
    
        return headers;
    }

    function handleAjaxError(jqXHR, textStatus, errorThrown, invalidate) {
        if (jqXHR.status === 401) {
            trigger(EVENT.GLOBAL.SESSION_LOGGED_OUT);
        }
        if (jqXHR.status === 403) {
            const summary = _.get(jqXHR, ['responseJSON', 'errors', 0, 'summary']);

            // if request denied due to buyer auth, suppress default messaging.
            if (summary !== 'AuthDowngraded' && summary !== 'AuthBlocked') {
                trigger(EVENT.GLOBAL.API_AUTH_FAILED);
            }
        }

        const state = jqXHR.state();

        if (state !== 'rejected') {
            trigger(EVENT.GLOBAL.PING);
        }

        // TODO: Wrap logging
        console.error(`AJAX Error: ${errorThrown}`, jqXHR);
        let errors = jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.errors ? jqXHR.responseJSON.errors : [];
        if (jqXHR && jqXHR.status === 500) {
            errors.splice(0, 0, {summary: jqXHR.responseText.replace(/(^")|("$)/g, '')});
        }
        if (invalidate && errors && errors.length) {
            invalidate({formError: _.head(errors).summary || 'An error occured, please try again.'});
        }

        return errors;
    }

    function ping(options = {}) {
        //// DISABLED:
        //Store.trigger("global:ping-success");
        //if(options && options.success) options.success();

        $.ajax({
            url: getApiUrl("/api/v1/auth/ping"),
            async: true,
            type: "GET",
            headers: getHeaders(),
            success: function (jqXHR, textStatus, errorThrown) {
                trigger(EVENT.GLOBAL.PING_SUCCESS);
                if (options.success) {
                    options.success();
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 401 || jqXHR.status === 403) {
                    trigger(EVENT.GLOBAL.PING_SUCCESS);
                    trigger(EVENT.GLOBAL.SESSION_LOGGED_OUT);
                }
                else {
                    trigger(EVENT.GLOBAL.PING_FAILED, jqXHR);
                    if (typeof(options.error) === 'function') {
                        options.error();
                    }
                }
            }
        });
    }

    return {
        ajax,
        getApiUrl,
        getContentUrl,
        getHeaders,
        handleAjaxError,
        ping
    };
}

module.exports = utils;